// Trustby client sec js start here 
var swiperInstances = null;
function initSwiperIfNeeded() {
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  // console.log("Is mobile:", isMobile, "Swiper instance:", swiperInstances);

  if (isMobile && !swiperInstances) {
    // console.log("Initializing new Swiper");
    swiperInstances = new Swiper('.trusted-by__client .swiper', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.trusted-by__client .swiper-button-next',
        prevEl: '.trusted-by__client .swiper-button-prev',
      },
    });
  } else if (!isMobile && swiperInstances) {
    // console.log("Destroying Swiper...");
    swiperInstances.destroy(true, true);
    swiperInstances = null;
  }
}

window.addEventListener('load', initSwiperIfNeeded);
window.addEventListener('resize', () => {
  setTimeout(initSwiperIfNeeded, 100);
});
// Trustby client sec js end here 

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".line-animate path").forEach(path => {
  const length = path.getTotalLength();

  path.style.strokeDasharray = length;
  path.style.strokeDashoffset = length;

  gsap.to(path, {
    strokeDashoffset: 0,
    duration: 2.2,
    ease: "power2.out",
    scrollTrigger: {
      trigger: path.closest("svg"),
      start: "top 90%",
      toggleActions: "play none none none"
    }
  });
});

const wrapper = document.querySelector("#tab1 .tab-innercontentwrapper");

ScrollTrigger.create({
  trigger: ".features__tabbing",
  start: "top 40%",
  once: true,
  onEnter: () => {
    const cards = [...wrapper.children];

    const shuffled = gsap.utils.shuffle(cards);

    const state = Flip.getState(cards);

    shuffled.forEach(card => wrapper.appendChild(card));

    Flip.from(state, {
      duration: 1.2,
      ease: "power2.inOut",
      stagger: 0.05
    });
  }
});


document.querySelectorAll('.shopify-store__leftitem').forEach((item) => {
  const scrollContainer = item.querySelector('[data-scroll-container]');
  const arrow = item.querySelector('[data-scroll-arrow]');
  const triggerSection = document.querySelector('.shopify-store__sec');

  ScrollTrigger.create({
    trigger: triggerSection,
    start: "top 70%",
    onEnter: () => {
      gsap.to(scrollContainer, {
        scrollTop: 1000,
        duration: 1,
        ease: 'power2.out'
      });
    },
  });
});

var gallerySlider = new Swiper('.gallery-slider', {
  effect: 'coverflow',
  loop: true,
  centeredSlides: true,
  slidesPerView: 3,
  spaceBetween: 100,
  coverflowEffect: {
    rotate: 0,
    stretch: 50,
    depth: 80,
    modifier: 1,
    slideShadows: false,
  },
  on: {
    init: function () {
      const activeSlide = this.slides[this.activeIndex];
      activeSlide.classList.add('custom-active-slide');
    }
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   var collectionslider = new Swiper('#product-grid .media.media--transparent.swiper', {
//     loop: true,
//     slidesPerView: 1,
//     spaceBetween: 10,
//     autoplay:false,
//     navigation: {
//       nextEl: '.collection_sliderbtn .swiper-button-next',
//       prevEl: '.collection_sliderbtn .swiper-button-prev',
//     },
//   });
// });
// var sliders = document.querySelectorAll('.product-card-wrapper .swiper');
// sliders.forEach(function(slider) {
//   new Swiper(slider, {
//     loop: true,
//     slidesPerView: 1,
//     spaceBetween: 10,
//     autoplay: false,
//     navigation: {
//       nextEl: slider.parentElement.querySelector('.swiper-button-next'),
//       prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
//     },
//   //   on: {
//   //   init: function () {
//   //     const activeSlide = this.slides[this.activeIndex];
//   //     activeSlide.classList.add('custom-active-slide');
//   //   }
//   // }
//   });
// });
var sliders = document.querySelectorAll('.product-card-wrapper .swiper');

sliders.forEach(function(slider) {
  new Swiper(slider, {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    autoplay: false,
    navigation: {
      nextEl: slider.parentElement.querySelector('.swiper-button-next'),
      prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
    },
    on: {
      init: function () {
        const realSlideIndex = this.realIndex;
        const realSlides = this.slides;
        realSlides.forEach((slide, index) => {
          if (index === this.activeIndex) {
            slide.classList.add('custom-active-slide');
          }
        });
      }
    }
  });
});

// var slider = new Swiper ('.product__media-list.swiper', {
//     slidesPerView: 1,
//     spaceBetween: 15,
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
// });

var thumbs = new Swiper ('.thumbnail-list.swiper', {
    slidesPerView: 5,
    spaceBetween: 15,
    loop: false,
    slideToClickedSlide: true,
});

if (window.enableInspectMode === false) {

  document.addEventListener('contextmenu', function(e) {
    e.preventDefault();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'F12' || (e.ctrlKey && (e.key === 'i' || e.key === 'I'))) {
      e.preventDefault();
    }
  });

  (function() {
    let devtools = /./;
    devtools.toString = function() {
    };
  })();
} else {

}

